<template>
  <div class="_container">
    <div class="_insideContainer">
      <div class="leftContainer">
        <div class="titleContainer"><Title type="light" :tag="$t('contactus.tag')" :title="$t('contactus.title')" /></div>
        <div class="_head">{{ $t("footer.bau") }}</div>
        <div class="_item1"><span>{{ $t("contactus.phone") }}</span><br />{{ contactData.phone || 'Yükleniyor...' }}</div>
        <div class="_item2"><span>{{ $t("contactus.address") }}</span><br /><span style="white-space: pre-wrap; font-weight:normal;">{{ contactData.address || 'Yükleniyor...' }}</span></div>
        <div class="_linkedIn" v-if="contactData.linkedin"><a :href="contactData.linkedin" target="_blank">{{ $t("linkedIn") }} Profilimiz İçin Tıklayınız</a></div>
      </div>

      <div class="rightContainer">
        <div class="_head1"><h4>{{ $t("contactus.form") }}:</h4></div>
        <div class="item1"><input v-model="form.email" :placeholder="$t('contactus.formEmail')" /></div>
        <div class="item1"><input v-model="form.name" :placeholder="$t('contactus.formName')" /></div>
        <div class="item1"><textarea v-model="form.message" :placeholder="$t('contactus.formMessage')" rows="4"></textarea></div>
        <div class="_buttonContainer"><div @click="sendMessage"><Button :text="isSending ? 'Gönderiliyor...' : $t('contactus.buttonText')" type="dark" /></div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "../common/Button.vue";
import Title from "../common/Title.vue";
import { getFirestore, doc, onSnapshot } from "firebase/firestore";
import { getApp } from "firebase/app";

const db = getFirestore(getApp());

export default {
  components: { Button, Title },
  data() { return { contactData: {}, form: { name: '', email: '', message: '' }, isSending: false }; },
  mounted() { onSnapshot(doc(db, "ayarlar", "anasayfa"), (docSnap) => { if (docSnap.exists()) this.contactData = docSnap.data(); }); },
  methods: {
    async sendMessage() {
      // 1. Alanların dolu olup olmadığını kontrol et
      if(!this.form.name || !this.form.email || !this.form.message) {
        return alert("Lütfen tüm alanları doldurunuz.");
      }

      this.isSending = true;

      try {
        // 2. FormSubmit API'sine bilgileri POST et (Doğrudan mail atar)
        const response = await fetch("https://formsubmit.co/ajax/info@baumind.com.tr", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            İsim: this.form.name,
            Eposta: this.form.email,
            Mesaj: this.form.message,
            _subject: "BAUMIND Web Sitesinden Yeni İletişim Mesajı" // Mailin konu başlığı
          })
        });

        if (response.ok) {
          alert("Mesajınız başarıyla iletildi. En kısa sürede size dönüş yapacağız.");
          this.form = { name: '', email: '', message: '' }; // Formu temizle
        } else {
          throw new Error("Sunucu hatası");
        }
      } catch (e) {
        alert("Mesaj gönderilirken bir ağ hatası oluştu. Lütfen daha sonra tekrar deneyiniz.");
        console.error(e);
      } finally {
        this.isSending = false;
      }
    }
  }
};
</script>

<style scoped>
._container { width: 100%; padding: 70px 5%; display: flex; justify-content: center; background-color: white; }
._insideContainer { width: 100%; max-width: 1900px; display: flex; flex-direction: row; }
._head { margin-bottom: 25px; font-family: "DM Sans", sans-serif; font-weight: 500; font-size: 18px; color: #000; }
._linkedIn a { color: #000; text-decoration: underline; font-weight: 500; font-size: 18px; } ._linkedIn a:hover { color: #0154a6; }
._item1, ._item2 { font-family: "DM Sans", sans-serif; font-size: 17px; margin-bottom: 25px; line-height: 1.5; color: #000;}
._item1 span, ._item2 span { font-weight: bold; }
.leftContainer { width: 50%; display: flex; flex-direction: column; }
.rightContainer { width: 50%; max-width: 700px; display: flex; flex-direction: column; }
._head1 h4 { font-size: 21px; margin-bottom: 20px; font-weight: 500; }
.rightContainer .item1 input, .rightContainer .item1 textarea { width: 100%; margin-bottom: 30px; padding: 10px 0; font-family: "DM Sans", sans-serif; font-size: 17px; background: transparent; border: 0; border-bottom: 1px solid rgba(0,0,0,0.2); outline: none; }
._buttonContainer { width: 200px; cursor: pointer; }
@media screen and (max-width: 1023px) { ._insideContainer { flex-direction: column; } .leftContainer, .rightContainer { width: 100%; } }
</style>